import {FormInstance} from 'antd/es/form';

import {getReferenceResolverFunction, IReferenceParamKey} from 'entities/metadata';
import {REFERENCE_RESOLVERS} from 'modules/data/data-constants';
import {IFormEntityData, IReferenceResolverParams, TEntity} from 'modules/data/data-types';

export const getReferenceResolver = (
    params?: IReferenceResolverParams,
    stringStructure?: string,
) => {
    const {referenceUrl, path} = params || {};
    const labelPath = path?.label ?? 'meaning';
    const valuePath = path?.value ?? 'id';
    const lookupCode = path?.lookupCode ?? 'lookupCode';
    const reserveLabelPath = path?.reserveLabel ?? 'description';
    return REFERENCE_RESOLVERS[String(referenceUrl)]
        || getReferenceResolverFunction(labelPath, valuePath, reserveLabelPath, lookupCode, stringStructure);
};

export const getReferenceParamsValues = (
    fieldKeys?: IReferenceParamKey[],
    form?: FormInstance,
    formData?: IFormEntityData,
    ) => {
    const values = JSON.parse(JSON.stringify(fieldKeys || ''));
    fieldKeys?.forEach((element: IReferenceParamKey, i: number) => {
        if (element && typeof element.to === 'string') {
            const keys = element.to.split('.');
            const toValue = keys[1]
                ? form?.getFieldValue(keys[0])?.[keys[1]] ?? (formData?.data?.[keys[0]]  as TEntity)?.[keys[1]]
                : form?.getFieldValue(keys[0]) ?? formData?.data?.[keys[0]];
            values[i].to = toValue ?? '';
        }
    });
    return values;
};
